"use client";

import { BarChart2, Database, Share2, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Achievements() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = [{
    icon: Database,
    title: "Data Preparation & Quality",
    description: "We clean, structure, validate, and organise information so that your reports and analysis are built on accurate and dependable data.",
    featured: false
  }, {
    icon: BarChart2,
    title: "Reporting & Dashboards",
    description: "We create clear management reports and intuitive dashboards that make performance indicators, trends, and important information easier to understand.",
    featured: true
  }, {
    icon: Share2,
    title: "Analysis & Decision Support",
    description: "We analyse trends, variances, risks, and opportunities to provide meaningful insight tailored to your organisation’s specific questions and priorities.",
    featured: false
  }];
  return <section data-section-id="7672" id="what-we-help-you-achieve" className="text-foreground py-24 md:py-32 font-default dark bg-accent">
      <div className="mx-auto max-w-[1240px] px-6 md:px-20">
        {}
        <div ref={ref} className={`mx-auto max-w-[720px] text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-default text-foreground text-[clamp(2.1rem,4vw,3.5rem)] font-medium leading-[1.08] tracking-[-0.02em]">Turn data into&nbsp;<em className="font-light italic" data-ast-id="f:/src/pages/DataAnalytics/sections/Achievements.tsx|sig:1wwakd" data-ast-start="1673" data-ast-end="1719" contenteditable="false" style={{}}>clarity</em>.</h2>
          <p className="mt-6 text-muted-foreground text-[clamp(1.0625rem,1.15vw,1.25rem)] leading-[1.6]">We help businesses organise complex information, improve reporting quality, and uncover insights that support stronger and more confident decisions.</p>
        </div>

        {}
        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`group relative flex flex-col rounded-lg bg-card border border-border p-8 shadow-lg transition-all duration-[280ms] ease-out hover:-translate-y-1 hover:shadow-xl ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: isVisible ? `${i * 90}ms` : "0ms",
            boxShadow: "inset 0 1px 0 hsl(0 0% 100% / 0.5), 0 1px 0 var(--border), 0 24px 48px -32px hsl(222 28% 11% / 0.12)"
          }}>
                {feature.featured && <Badge className="absolute top-5 right-5 bg-secondary text-secondary-foreground rounded-lg px-3 py-1 text-xs font-semibold">
                    Top Choice
                  </Badge>}

                {}
                <div className={`flex h-16 w-16 items-center justify-center rounded-lg ${feature.featured ? "bg-secondary" : "bg-accent"}`}>
                  <Icon className={`h-7 w-7 ${feature.featured ? "text-secondary-foreground" : "text-accent-foreground"}`} strokeWidth={1.75} />
                </div>

                {}
                <h3 className="mt-8 font-default text-foreground text-[clamp(1.25rem,1.6vw,1.5rem)] font-semibold leading-[1.25] tracking-[-0.01em] !w-[320px]">
                  {feature.title}
                </h3>

                {}
                <p className="mt-4 flex-1 text-muted-foreground text-base leading-[1.65]">
                  {feature.description}
                </p>

                {}
                <div className="mt-8">
                  <Button asChild variant="link" className="h-auto p-0 text-foreground hover:no-underline font-semibold">
                    <Link to="/OurServicesPage" className="inline-flex items-center gap-1">
                      
                      
                    </Link>
                  </Button>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}